<footer class="footer">
  <section class="footer__cta">
    <div class="grid-principal">
      <a class="footer__cta-col" routerLink="/sucursales">
        <span>Encuentra tu sucursal más cercana</span>
        <img ngSrc="/icons/black-right.arrow.svg" width="26" height="15" alt="" />
      </a>
      <a class="footer__cta-col" routerLink="/contacto">
        <span>Agenda una cita</span>
        <img ngSrc="/icons/black-right.arrow.svg" width="26" height="15" alt="" />
      </a>
    </div>
  </section>

  <section class="footer__main">
    <div class="footer__inner">
      <div class="footer__top-row">
        <div class="footer__brand">
          <img
            class="footer__logo"
            ngSrc="/logos/logo_mack_white.webp"
            width="193"
            height="60"
            alt="Mack Trucks"
          />
          <div class="footer__social">
            @for (item of socialMedia(); track item.id) {
              <a [href]="item.url" target="_blank" rel="noopener noreferrer" [attr.aria-label]="item.title">
                <img [ngSrc]="item.icon.image" [alt]="item.icon.alt" width="18" height="18" />
              </a>
            }
          </div>
        </div>

        <nav class="footer__nav">
          <ul class="footer__nav-col">
            <li><a routerLink="/servicio">Servicio</a></li>
            <li><a routerLink="/camiones">Camiones</a></li>
            <li><a href="https://tienda.camionesmack.mx/" target="_blank">Refacciones</a></li>
          </ul>
          <ul class="footer__nav-col">
            <li><a routerLink="/programas-integrales">Programas integrales</a></li>
            <li><a routerLink="/mack-financial-services">Mack Financial</a></li>
            <li><a routerLink="/quienes-somos">Empresa</a></li>
          </ul>
          <ul class="footer__nav-col">
            <li><a routerLink="/sucursales">Sucursales</a></li>
            <li><a routerLink="/contacto">Contacto</a></li>
            <li><a routerLink="/blog">Blog</a></li>
          </ul>
          <div class="footer__certs">
            <img
              ngSrc="/logos/gptw-esr.webp"
              width="194"
              height="86"
              alt="Great Place to Work & ESR"
            />
          </div>
        </nav>
      </div>

      <hr class="footer__divider" />

      <div class="footer__contact-row">
        <p class="footer__address">
          West Plaza Park, México 15 4935-9, San Juan de Ocotán, 45010 Zapopan, Jal.
        </p>
        <div class="footer__hours">
          <p>Lunes a viernes de 9:00 am a 6:00 pm</p>
          <p>Sábados 9:00 a 2:00 pm</p>
        </div>
        @if (config()?.email) {
          <a class="footer__contact-item" [href]="'mailto:' + config()!.email">
            <svg width="20" height="14" viewBox="0 0 20 14" fill="currentColor">
              <path
                d="M18 0H2C.9 0 0 .9 0 2v10c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V2l8 5 8-5v2z"
              />
            </svg>
            <span>{{ config()!.email }}</span>
          </a>
        }
        <a class="footer__contact-item" href="tel:8006343735">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
            <path
              d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"
            />
          </svg>
          <span>800 634 3735</span>
        </a>
      </div>

      <hr class="footer__divider" />

      <div class="footer__policies">
        <a routerLink="/legales/politica-anticorrupcion">Política anticorrupción</a>
        <a routerLink="/legales/politica-de-cookies">Política de cookies</a>
        <a routerLink="/legales/politicas-de-envios-y-devoluciones">Políticas de envíos y devoluciones</a>
        <a routerLink="/legales/politica-de-calidad-y-responsabilidad-social">Política de calidad y responsabilidad social</a>
      </div>

      <hr class="footer__divider" />

      <div class="footer__legal">
        <p class="footer__copyright">
          {{ currentYear }} Camiones Mack. Todos los derechos reservados.
        </p>
        <div class="footer__legal-links">
          <a routerLink="/legales/aviso-de-privacidad">Aviso de privacidad</a>
          <a routerLink="/legales/terminos-y-condiciones">Términos y condiciones</a>
          <a routerLink="/legales/codigo-de-etica">Código de ética</a>
        </div>
        <p class="footer__denuncia">Línea de denuncia: <a href="tel:8000438422">800 043 8422</a></p>
      </div>
    </div>
  </section>
</footer>
